import { v4 as uuidv4 } from 'uuid';

const UUID_KEY = 'hsylc-uuid';

let sessionId = null;

function createBrowserUuid() {
  const uuid = uuidv4();
  localStorage.setItem(UUID_KEY, uuid);
  return uuid;
}

export function getBrowserUuid() {
  return localStorage.getItem(UUID_KEY) || createBrowserUuid();
}

export function getSessionId() {
  if (!sessionId) {
    sessionId = uuidv4();
  }
  return sessionId;
}

export function resolveReportIds() {
  return {
    uuid: getBrowserUuid(),
    sessionId: getSessionId()
  };
}
